import { Button, Menu, PlusIcon } from '@datavant/dart';
import { useRouter } from 'next/router';
import React from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { useOrderManagementPermissions } from '../lib/useOrderManagementPermissions';

export const NewButtonMenu = () => {
    const [sideNavExpanded] = useLocalStorage('idsb-sidebar-open', true);
    const router = useRouter();
    const { userCanCreateOrderTemplates, userCanCreateOrders, userCanCreateProjects } =
        useOrderManagementPermissions();

    if (!userCanCreateProjects && !userCanCreateOrderTemplates && !userCanCreateOrders) {
        return null;
    }

    return (
        <Menu position="bottom-start">
            <Menu.Target>
                {/* Wrapper div required because Dart's Button doesn't forward refs.
                    Without it, Mantine's Floating UI can't locate the target element
                    and the dropdown positions at (0,0) of the nearest container. */}
                <div
                    style={{
                        width: 'fit-content',
                        margin: sideNavExpanded ? undefined : '0 auto',
                    }}
                >
                    <Button
                        intent="prominent"
                        size={sideNavExpanded ? undefined : 'compact-xs'}
                        style={{ whiteSpace: 'nowrap' }}
                    >
                        <PlusIcon />
                        {sideNavExpanded && 'New'}
                    </Button>
                </div>
            </Menu.Target>
            <Menu.Dropdown style={{ minWidth: 256, zIndex: 10000 }}>
                {userCanCreateProjects && (
                    <Menu.Item onClick={() => void router.push('/order-management/project')}>
                        New Project
                    </Menu.Item>
                )}
                {userCanCreateOrders && (
                    <Menu.Item onClick={() => void router.push('/order-management/order')}>
                        New Order
                    </Menu.Item>
                )}
                {userCanCreateOrderTemplates && (
                    <Menu.Item onClick={() => void router.push('/order-management/order-templates/create')}>
                        New Order Template
                    </Menu.Item>
                )}
            </Menu.Dropdown>
        </Menu>
    );
};
